(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section--collection-grid-gallery"] && !Shopify.designMode) return;
  try {
    
class GalleryWallCard extends HTMLElement {
  #activeColour = null;
  #imagePairs = null;
  #swatches = null;
  #swatchContainer = null;
  #productLink = null;
  #boundHandlers = new Map();
  #fadeTimer = null;

  connectedCallback() {
    this.#imagePairs = this.querySelectorAll('[data-variant-colour]');
    this.#swatches = this.querySelectorAll('[data-colour]');
    this.#swatchContainer = this.querySelector('[data-swatch-container]');
    this.#productLink = this.querySelector('[data-product-link]');

    if (this.#swatches.length === 0) return;

    const firstSwatch = this.#swatches[0];
    const initialColour = this.dataset.activeColour;
    this.#activeColour = initialColour || firstSwatch.dataset.colour;

    for (const swatch of this.#swatches) {
      const clickHandler = this.#handleSwatchClick.bind(this);
      const enterHandler = this.#handleSwatchEnter.bind(this);
      const keyHandler = this.#handleKeydown.bind(this);

      swatch.addEventListener('click', clickHandler);
      swatch.addEventListener('mouseenter', enterHandler);
      swatch.addEventListener('keydown', keyHandler);

      this.#boundHandlers.set(swatch, { clickHandler, enterHandler, keyHandler });
    }

    if (this.#swatchContainer) {
      const leaveHandler = this.#handleSwatchLeave.bind(this);
      this.#swatchContainer.addEventListener('mouseleave', leaveHandler);
      this.#boundHandlers.set(this.#swatchContainer, { leaveHandler });
    }
  }

  disconnectedCallback() {
    for (const swatch of this.#swatches) {
      const handlers = this.#boundHandlers.get(swatch);
      if (!handlers) continue;
      swatch.removeEventListener('click', handlers.clickHandler);
      swatch.removeEventListener('mouseenter', handlers.enterHandler);
      swatch.removeEventListener('keydown', handlers.keyHandler);
    }

    if (this.#swatchContainer) {
      const handlers = this.#boundHandlers.get(this.#swatchContainer);
      if (handlers?.leaveHandler) {
        this.#swatchContainer.removeEventListener('mouseleave', handlers.leaveHandler);
      }
    }

    this.#boundHandlers.clear();
    clearTimeout(this.#fadeTimer);
  }

  #handleSwatchClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const swatch = event.currentTarget;
    const colour = swatch.dataset.colour;

    this.#activeColour = colour;
    this.#showVariant(colour);
    this.#updateActiveRing(colour);
    this.#updateProductLink(swatch.dataset.variantId);
  }

  #handleSwatchEnter(event) {
    const colour = event.currentTarget.dataset.colour;
    this.#showVariant(colour);
  }

  #handleSwatchLeave() {
    this.#showVariant(this.#activeColour);
  }

  #handleKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.#handleSwatchClick(event);
    }
  }

  #showVariant(colour) {
    clearTimeout(this.#fadeTimer);

    for (const pair of this.#imagePairs) {
      if (pair.dataset.variantColour === colour) {
        pair.style.zIndex = '1';
        pair.classList.remove('opacity-0', 'pointer-events-none');
      }
    }

    this.#fadeTimer = setTimeout(() => {
      for (const pair of this.#imagePairs) {
        if (pair.dataset.variantColour !== colour) {
          pair.classList.add('opacity-0', 'pointer-events-none');
        }
        pair.style.zIndex = '';
      }
    }, 300);
  }

  #updateActiveRing(colour) {
    for (const swatch of this.#swatches) {
      const isActive = swatch.dataset.colour === colour;
      swatch.classList.toggle('ring-stone-900', isActive);
      swatch.classList.toggle('ring-transparent', !isActive);
    }
  }

  #updateProductLink(variantId) {
    if (!this.#productLink || !variantId) return;
    const baseUrl = this.#productLink.getAttribute('href').split('?')[0];
    this.#productLink.setAttribute('href', `${baseUrl}?variant=${variantId}`);
  }
}

customElements.define('gallery-wall-card', GalleryWallCard);

(function () {
  const SECTION_SELECTOR = '.collection-grid-gallery';
  const FILTER_SELECTOR = '[data-filter-param]';
  let controller = null;

  document.addEventListener('click', (event) => {
    const link = event.target.closest(FILTER_SELECTOR);
    if (!link) return;

    const section = link.closest(SECTION_SELECTOR);
    if (!section) return;

    event.preventDefault();

    const param = link.dataset.filterParam;
    const value = link.dataset.filterValue;
    const baseUrl = section.dataset.collectionUrl || window.location.pathname;
    const url = buildFilterUrl(baseUrl, param, value);

    loadFilteredSection(section, url, true);
  });

  window.addEventListener('popstate', () => {
    const section = document.querySelector(SECTION_SELECTOR);
    if (section) loadFilteredSection(section, window.location.href, false);
  });

  function buildFilterUrl(baseUrl, toggleParam, toggleValue) {
    const params = new URLSearchParams(window.location.search);

    if (!toggleValue) {
      params.delete(toggleParam);
    } else if (params.get(toggleParam) === toggleValue) {
      params.delete(toggleParam);
    } else {
      params.set(toggleParam, toggleValue);
    }

    const qs = params.toString();
    return qs ? `${baseUrl}?${qs}` : baseUrl;
  }

  async function loadFilteredSection(section, url, pushState) {
    const sectionId = section.dataset.sectionId;
    if (!sectionId) return;

    section.style.opacity = '0.5';
    section.style.pointerEvents = 'none';
    section.style.transition = 'opacity 150ms';

    controller?.abort();
    controller = new AbortController();

    try {
      const fetchUrl = new URL(url, window.location.origin);
      fetchUrl.searchParams.set('sections', sectionId);

      const response = await fetch(fetchUrl, { signal: controller.signal });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const data = await response.json();
      const html = data[sectionId];

      const temp = new DOMParser().parseFromString(html, 'text/html');
      const newSection = temp.querySelector('section');

      if (newSection) {
        section.innerHTML = newSection.innerHTML;
        for (const attr of newSection.attributes) {
          section.setAttribute(attr.name, attr.value);
        }
      }

      if (pushState) history.pushState({}, '', url);
    } catch (error) {
      if (error.name !== 'AbortError') {
        window.location.href = url;
      }
    } finally {
      section.style.opacity = '';
      section.style.pointerEvents = '';
      section.style.transition = '';
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section--frame-styles"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.section--frame-styles').forEach((root) => {
    if (root.dataset.fsReady) return;
    root.dataset.fsReady = '1';

    const viewport = root.querySelector('.fs__viewport');
    const track = root.querySelector('.fs__track');
    const dotsWrap = root.querySelector('.fs__dots');
    const prev = root.querySelector('.fs__nav--prev');
    const next = root.querySelector('.fs__nav--next');
    if (!viewport || !track || !dotsWrap) return;

    const cards = () => [...viewport.querySelectorAll('.fs__card')];
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function step() {
      const card = cards()[0];
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return (card ? card.getBoundingClientRect().width : 200) + gap;
    }

    function paint() {
      const list = cards();
      const count = Math.max(1, list.length);
      const max = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const x = viewport.scrollLeft;
      if (prev) prev.disabled = x <= 2;
      if (next) next.disabled = x >= max - 2;
      const index = max <= 2 ? 0 : Math.round((x / max) * (count - 1));
      dotsWrap.replaceChildren();
      list.forEach((card, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'fs__dot' + (i === index ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Show ' + (card.querySelector('.fs__name')?.textContent || 'frame'));
        dot.addEventListener('click', () => {
          const left = i === 0 ? 0 : card.offsetLeft;
          viewport.scrollTo({ left, behavior: reduced ? 'auto' : 'smooth' });
        });
        dotsWrap.appendChild(dot);
      });
    }

    prev?.addEventListener('click', () => {
      viewport.scrollBy({ left: -step(), behavior: reduced ? 'auto' : 'smooth' });
    });
    next?.addEventListener('click', () => {
      viewport.scrollBy({ left: step(), behavior: reduced ? 'auto' : 'smooth' });
    });
    viewport.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint);
    paint();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section--gallery-wall-floating-bar"] && !Shopify.designMode) return;
  try {
    
class GalleryWallBar extends HTMLElement {
  #wasVisible = false;

  #heroEl = null;

  #onScroll = () => {
    this.#checkVisibility();
  };

  #checkVisibility() {
    if (!this.#heroEl || !this.#heroEl.isConnected) {
      this.#heroEl = document.querySelector('gallery-wall-hero');
    }
    if (!this.#heroEl) return;

    const heroBottom = this.#heroEl.getBoundingClientRect().bottom;
    const isVisible = heroBottom < window.innerHeight * 0.85;

    if (isVisible !== this.#wasVisible) {
      this.classList.toggle('gallery-wall-bar--visible', isVisible);

      if (isVisible) {
        const line = this.querySelector('.gallery-wall-bar__cta-underline');
        if (line) {
          line.classList.remove('gallery-wall-bar__cta-underline--animate');
          void line.getBoundingClientRect();
          line.classList.add('gallery-wall-bar__cta-underline--animate');
        }
      }
    }
    this.#wasVisible = isVisible;
  }

  #onClickOutside = (event) => {
    if (!this.contains(event.target)) {
      this.#closePanel();
    }
  };

  connectedCallback() {
    if (this.parentElement !== document.body) {
      document.body.appendChild(this);
      return;
    }

    this.swatches = this.querySelectorAll('.gallery-wall-bar__swatch');
    this.sizeBtns = this.querySelectorAll('.gallery-wall-bar__size-btn');
    this.colourName = this.querySelector('[data-colour-name]');
    this.uploadLink = this.querySelector('[data-upload-link]');
    this.priceEl = this.querySelector('[data-cta-price]');
    this.productHandle = this.dataset.productHandle;

    for (const swatch of this.swatches) {
      swatch.addEventListener('click', this.#handleSwatchClick.bind(this));
    }

    for (const btn of this.sizeBtns) {
      btn.addEventListener('click', this.#handleSizeClick.bind(this));
    }

    window.addEventListener('scroll', this.#onScroll, { passive: true });
    window.addEventListener('scrollend', this.#onScroll, { passive: true });
    this.#checkVisibility();

    const cta = this.querySelector('.gallery-wall-bar__cta');
    if (cta) {
      cta.addEventListener('mouseenter', () => {
        const line = this.querySelector('.gallery-wall-bar__cta-underline');
        if (line) {
          line.classList.remove('gallery-wall-bar__cta-underline--animate');
          void line.getBoundingClientRect();
          line.classList.add('gallery-wall-bar__cta-underline--animate');
        }
      });
    }

    const detailsToggle = this.querySelector('[data-details-toggle]');
    if (detailsToggle) {
      detailsToggle.addEventListener('click', () => this.#togglePanel());
    }

    document.addEventListener('gallery-wall:colour-change', (event) => {
      if (event.detail.source === 'bar') return;
      this.#syncColour(event.detail.colour, event.detail);
    });

    document.addEventListener('gallery-wall:size-change', (event) => {
      this.#syncSize(event.detail.size, event.detail);
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.#onScroll);
    window.removeEventListener('scrollend', this.#onScroll);
    document.removeEventListener('click', this.#onClickOutside);
  }

  #togglePanel() {
    if (this.classList.contains('gallery-wall-bar--details-open')) {
      this.#closePanel();
    } else {
      this.classList.add('gallery-wall-bar--details-open');
      requestAnimationFrame(() => {
        document.addEventListener('click', this.#onClickOutside);
      });
    }
  }

  #closePanel() {
    this.classList.remove('gallery-wall-bar--details-open');
    document.removeEventListener('click', this.#onClickOutside);
  }

  #syncColour(colour, detail) {
    const matchingSwatch = this.querySelector(`.gallery-wall-bar__swatch[data-colour="${colour}"]`);
    if (!matchingSwatch) return;

    for (const s of this.swatches) {
      s.classList.remove('gallery-wall-bar__swatch--active');
      s.setAttribute('aria-pressed', 'false');
    }
    matchingSwatch.classList.add('gallery-wall-bar__swatch--active');
    matchingSwatch.setAttribute('aria-pressed', 'true');

    if (this.colourName) {
      this.colourName.textContent = colour;
    }

    if (this.priceEl && detail.price) {
      this.priceEl.textContent = detail.price;
    }

    if (this.uploadLink && detail.sku) {
      this.uploadLink.href = `/apps/frame/gallery-walls/${this.productHandle}/styles/${detail.sku}`;
    }

    for (const section of this.querySelectorAll('[data-panel-colour]')) {
      section.classList.toggle('gallery-wall-bar__panel-section--hidden', section.dataset.panelColour !== colour);
    }
  }

  #handleSizeClick(event) {
    const btn = event.currentTarget;
    const size = btn.dataset.size;

    for (const b of this.sizeBtns) {
      b.classList.remove('gallery-wall-bar__size-btn--active');
      b.setAttribute('aria-pressed', 'false');
    }
    btn.classList.add('gallery-wall-bar__size-btn--active');
    btn.setAttribute('aria-pressed', 'true');

    document.dispatchEvent(new CustomEvent('gallery-wall:size-change', {
      detail: { size },
      bubbles: false
    }));
  }

  #syncSize(size, detail) {
    const matchingBtn = this.querySelector(`.gallery-wall-bar__size-btn[data-size="${size}"]`);
    if (!matchingBtn) return;

    for (const b of this.sizeBtns) {
      b.classList.remove('gallery-wall-bar__size-btn--active');
      b.setAttribute('aria-pressed', 'false');
    }
    matchingBtn.classList.add('gallery-wall-bar__size-btn--active');
    matchingBtn.setAttribute('aria-pressed', 'true');

    if (this.priceEl && detail.price) {
      this.priceEl.textContent = detail.price;
    }
    if (this.uploadLink && detail.sku) {
      this.uploadLink.href = `/apps/frame/gallery-walls/${this.productHandle}/styles/${detail.sku}`;
    }
  }

  #handleSwatchClick(event) {
    const swatch = event.currentTarget;
    const colour = swatch.dataset.colour;
    const sku = swatch.dataset.variantSku;
    const price = swatch.dataset.variantPrice;

    for (const s of this.swatches) {
      s.classList.remove('gallery-wall-bar__swatch--active');
      s.setAttribute('aria-pressed', 'false');
    }
    swatch.classList.add('gallery-wall-bar__swatch--active');
    swatch.setAttribute('aria-pressed', 'true');

    if (this.colourName) {
      this.colourName.textContent = colour;
    }

    if (this.priceEl && price) {
      this.priceEl.textContent = price;
    }

    if (this.uploadLink && sku) {
      this.uploadLink.href = `/apps/frame/gallery-walls/${this.productHandle}/styles/${sku}`;
    }

    for (const section of this.querySelectorAll('[data-panel-colour]')) {
      section.classList.toggle('gallery-wall-bar__panel-section--hidden', section.dataset.panelColour !== colour);
    }

    document.dispatchEvent(new CustomEvent('gallery-wall:colour-change', {
      detail: { colour, sku, price, source: 'bar' },
      bubbles: false
    }));
  }
}

customElements.define('gallery-wall-bar', GalleryWallBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section--gallery-wall-hero"] && !Shopify.designMode) return;
  try {
    
class GalleryWallHero extends HTMLElement {
  #currentColour = '';
  #currentSize = '';
  #variants = [];

  connectedCallback() {
    const jsonEl = this.querySelector('[data-variant-json]');
    if (jsonEl) {
      try { this.#variants = JSON.parse(jsonEl.textContent); } catch {}
    }

    this.swatches = this.querySelectorAll('.gallery-wall-hero__swatch');
    this.sizeBtns = this.querySelectorAll('.gallery-wall-hero__size-btn');
    this.panelSections = this.querySelectorAll('[data-hero-panel-colour]');
    this.colourName = this.querySelector('[data-hero-colour-name]');
    this.uploadLink = this.querySelector('[data-hero-upload-link]');
    this.priceEl = this.querySelector('[data-hero-price]');
    this.comparePriceEl = this.querySelector('[data-hero-compare-price]');
    this.saveTagEl = this.querySelector('[data-hero-save-tag]');
    this.afterpayEl = this.querySelector('[data-hero-afterpay-price]');
    this.dimensionsEl = this.querySelector('[data-hero-dimensions]');
    this.specsDimensionsEl = this.querySelector('[data-hero-specs-dimensions]');
    this.productHandle = this.dataset.productHandle;

    const activeSwatch = this.querySelector('.gallery-wall-hero__swatch--active');
    if (activeSwatch) this.#currentColour = activeSwatch.dataset.colour;

    const activeSize = this.querySelector('.gallery-wall-hero__size-btn--active');
    if (activeSize) this.#currentSize = activeSize.dataset.size;

    for (const swatch of this.swatches) {
      swatch.addEventListener('click', this.#handleSwatchClick.bind(this));
    }

    for (const btn of this.sizeBtns) {
      btn.addEventListener('click', this.#handleSizeClick.bind(this));
    }

    this.#initDispatchDate();

    document.addEventListener('gallery-wall:colour-change', (event) => {
      if (event.detail.source === 'hero') return;
      this.#syncColour(event.detail.colour, event.detail);
    });

    document.addEventListener('gallery-wall:size-change', (event) => {
      if (event.detail.source === 'hero') return;
      this.#syncSize(event.detail.size);
    });
  }

  #handleSwatchClick(event) {
    const swatch = event.currentTarget;
    const colour = swatch.dataset.colour;
    this.#currentColour = colour;

    this.#setActiveSwatches(swatch);
    this.#updateHeroImages(colour);
    this.#updatePanels(colour);

    const variant = this.#resolveVariant();
    this.#updateCta(variant);

    document.dispatchEvent(new CustomEvent('gallery-wall:colour-change', {
      detail: { colour, sku: variant?.sku, price: variant?.price, source: 'hero' },
      bubbles: false
    }));
  }

  #handleSizeClick(event) {
    const btn = event.currentTarget;
    this.#currentSize = btn.dataset.size;

    for (const b of this.sizeBtns) {
      b.classList.remove('gallery-wall-hero__size-btn--active');
      b.setAttribute('aria-pressed', 'false');
    }
    btn.classList.add('gallery-wall-hero__size-btn--active');
    btn.setAttribute('aria-pressed', 'true');

    const variant = this.#resolveVariant();
    this.#updateCta(variant);

    document.dispatchEvent(new CustomEvent('gallery-wall:size-change', {
      detail: { size: this.#currentSize, sku: variant?.sku, price: variant?.price, source: 'hero' },
      bubbles: false
    }));

    if (variant) {
      document.dispatchEvent(new CustomEvent('gallery-wall:colour-change', {
        detail: { colour: this.#currentColour, sku: variant.sku, price: variant.price, source: 'hero' },
        bubbles: false
      }));
    }
  }

  #syncSize(size) {
    this.#currentSize = size;
    const matchingBtn = this.querySelector(`.gallery-wall-hero__size-btn[data-size="${size}"]`);
    if (matchingBtn) {
      for (const b of this.sizeBtns) {
        b.classList.remove('gallery-wall-hero__size-btn--active');
        b.setAttribute('aria-pressed', 'false');
      }
      matchingBtn.classList.add('gallery-wall-hero__size-btn--active');
      matchingBtn.setAttribute('aria-pressed', 'true');
    }

    const variant = this.#resolveVariant();
    this.#updateCta(variant);

    if (variant) {
      document.dispatchEvent(new CustomEvent('gallery-wall:size-change', {
        detail: { size, sku: variant.sku, price: variant.price, source: 'hero' },
        bubbles: false
      }));
      document.dispatchEvent(new CustomEvent('gallery-wall:colour-change', {
        detail: { colour: this.#currentColour, sku: variant.sku, price: variant.price, source: 'hero' },
        bubbles: false
      }));
    }
  }

  #syncColour(colour, detail) {
    this.#currentColour = colour;
    const matchingSwatch = this.querySelector(`.gallery-wall-hero__swatch[data-colour="${colour}"]`);
    if (matchingSwatch) {
      this.#setActiveSwatches(matchingSwatch);
      this.#updateHeroImages(colour);
      this.#updatePanels(colour);
    }
    const variant = this.#resolveVariant();
    this.#updateCta(variant);
  }

  #resolveVariant() {
    if (this.#variants.length === 0) return null;

    if (this.#currentSize && this.#currentColour) {
      const match = this.#variants.find(v => v.colour === this.#currentColour && v.size === this.#currentSize);
      if (match) return match;
    }

    if (this.#currentColour) {
      const match = this.#variants.find(v => v.colour === this.#currentColour);
      if (match) return match;
    }

    if (this.#currentSize) {
      const match = this.#variants.find(v => v.size === this.#currentSize);
      if (match) return match;
    }

    return this.#variants[0];
  }

  #initDispatchDate() {
    const el = this.querySelector('[data-dispatch-days]');
    if (!el) return;
    const label = el.querySelector('[data-dispatch-label]');
    if (!label) return;

    const days = el.dataset.dispatchDays;
    const setLabel = () => {
      if (typeof window.getDispatchDate === 'function') {
        const result = window.getDispatchDate(days);
        label.textContent = `Order now, dispatched by ${result.long}`;
      }
    };

    if (typeof window.getDispatchDate === 'function') {
      setLabel();
    } else {
      window.addEventListener('load', setLabel);
    }
  }

  #setActiveSwatches(activeSwatch) {
    for (const s of this.swatches) {
      s.classList.remove('gallery-wall-hero__swatch--active');
      s.setAttribute('aria-pressed', 'false');
    }
    activeSwatch.classList.add('gallery-wall-hero__swatch--active');
    activeSwatch.setAttribute('aria-pressed', 'true');

    if (this.colourName) {
      this.colourName.textContent = activeSwatch.dataset.colour;
    }
  }

  #updateHeroImages(colour) {
    for (const layer of this.querySelectorAll('[data-hero-colour]')) {
      layer.classList.toggle('gallery-wall-hero__layer--hidden', layer.dataset.heroColour !== colour);
    }
  }

  #updatePanels(colour) {
    for (const section of this.panelSections) {
      section.classList.toggle('gallery-wall-hero__frame-section--hidden', section.dataset.heroPanelColour !== colour);
    }
  }

  #updateCta(variant) {
    if (!variant) return;
    if (this.uploadLink) {
      this.uploadLink.href = `/apps/frame/gallery-walls/${this.productHandle}/styles/${variant.sku}`;
    }
    if (this.priceEl) {
      this.priceEl.textContent = variant.price;
    }
    if (this.comparePriceEl) {
      if (variant.compareAtPrice) {
        this.comparePriceEl.textContent = variant.compareAtPrice;
        this.comparePriceEl.classList.remove('gallery-wall-hero__compare-price--hidden');
      } else {
        this.comparePriceEl.textContent = '';
        this.comparePriceEl.classList.add('gallery-wall-hero__compare-price--hidden');
      }
    }
    if (this.saveTagEl) {
      if (variant.compareAtPrice) {
        const numericPrice = parseFloat(variant.price.replace(/[^0-9.]/g, ''));
        const numericCompare = parseFloat(variant.compareAtPrice.replace(/[^0-9.]/g, ''));
        const savePct = Math.round((numericCompare - numericPrice) / numericCompare * 100);
        this.saveTagEl.textContent = `Save ${savePct}% with bundle`;
        this.saveTagEl.classList.remove('gallery-wall-hero__save-tag--hidden');
      } else {
        this.saveTagEl.textContent = '';
        this.saveTagEl.classList.add('gallery-wall-hero__save-tag--hidden');
      }
    }
    if (this.afterpayEl) {
      const numericPrice = parseFloat(variant.price.replace(/[^0-9.]/g, ''));
      if (!Number.isNaN(numericPrice)) {
        const installment = (numericPrice / 4).toFixed(2);
        const formatted = variant.price.replace(/[\d,.]+/, installment.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
        this.afterpayEl.textContent = formatted;
      }
    }
    if (variant.width && variant.height) {
      const dimHtml = `${variant.width} &times; ${variant.height} cm`;
      if (this.dimensionsEl) this.dimensionsEl.innerHTML = dimHtml;
      if (this.specsDimensionsEl) this.specsDimensionsEl.innerHTML = dimHtml;
    }
  }
}

customElements.define('gallery-wall-hero', GalleryWallHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section--main-teasers"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.section--main-teasers').forEach((root) => {
    if (root.dataset.mtReady) return;
    root.dataset.mtReady = '1';

    const viewport = root.querySelector('.mt__viewport');
    const dotsWrap = root.querySelector('.mt__dots');
    if (!viewport || !dotsWrap) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const cards = () => [...viewport.querySelectorAll('.mt__card')];

    function paint() {
      const list = cards();
      const count = Math.max(1, list.length);
      const max = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const index = max <= 2 ? 0 : Math.round((viewport.scrollLeft / max) * (count - 1));
      dotsWrap.replaceChildren();
      if (max <= 2) return;
      list.forEach((card, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'mt__dot' + (i === index ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Show teaser ' + (i + 1));
        dot.addEventListener('click', () => {
          viewport.scrollTo({ left: i === 0 ? 0 : card.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
        });
        dotsWrap.appendChild(dot);
      });
    }

    viewport.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint);
    paint();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section--ugc-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.section--ugc-reviews').forEach((root) => {
    if (root.dataset.ugcReady) return;
    root.dataset.ugcReady = '1';

    const viewport = root.querySelector('.ugc__viewport');
    const dotsWrap = root.querySelector('.ugc__dots');
    const prev = root.querySelector('.ugc__nav--prev');
    const next = root.querySelector('.ugc__nav--next');
    if (!viewport || !dotsWrap) return;

    const cards = () => [...viewport.querySelectorAll('.ugc__card')];
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function nearestIndex() {
      const list = cards();
      const start = viewport.getBoundingClientRect().left;
      let index = 0;
      let best = Infinity;
      list.forEach((card, i) => {
        const distance = Math.abs(card.getBoundingClientRect().left - start);
        if (distance < best) {
          best = distance;
          index = i;
        }
      });
      return index;
    }

    function scrollToCard(index) {
      const list = cards();
      const card = list[index];
      if (!card) return;
      const left = index === 0 ? 0 : card.offsetLeft;
      viewport.scrollTo({ left, behavior: reduced ? 'auto' : 'smooth' });
    }

    function paint() {
      const list = cards();
      const max = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const x = viewport.scrollLeft;
      if (prev) prev.disabled = x <= 2;
      if (next) next.disabled = x >= max - 2;
      const active = max <= 2 ? 0 : nearestIndex();
      dotsWrap.replaceChildren();
      list.forEach((card, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ugc__dot' + (i === active ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Show panel ' + (i + 1));
        dot.addEventListener('click', () => scrollToCard(i));
        dotsWrap.appendChild(dot);
      });
    }

    prev?.addEventListener('click', () => scrollToCard(nearestIndex() - 1));
    next?.addEventListener('click', () => scrollToCard(nearestIndex() + 1));
    viewport.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint);
    paint();
  });

  } catch(e) { console.error(e); }
})();
})();
